/* section-header.js — extracted from sections/header.liquid */
  function initSiteHeader() {
    let header = document.getElementById('site-header');
    let sentinel = document.getElementById('header-sentinel');
    let menuToggle = header && header.querySelector('.header__menu-toggle');
    let mobileMenu = document.getElementById('mobile-menu');
    let mobileClose = mobileMenu && mobileMenu.querySelector('.mobile-menu__close');

    if (!header) return;

    /* ── Sticky header ── */
    if (sentinel && header.dataset.sticky) {
      new IntersectionObserver(function (entries) {
        header.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinel);
    }

    /* ── Mobile menu ── */
    function openMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.showModal();
      document.body.style.overflow = 'hidden';
      menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.close();
      document.body.style.overflow = '';
      menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle && menuToggle.focus();
    }

    menuToggle && menuToggle.addEventListener('click', openMobileMenu);
    mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
    mobileMenu && mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) closeMobileMenu();
    });
    mobileMenu && mobileMenu.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeMobileMenu();
    });

    /* ── Mega-menu ── */
    if (header) {
      let clickOnly = header.hasAttribute('data-click-only');
      let megaItems = header.querySelectorAll('.header__nav-item--mega');

      function closeAllMega() {
        megaItems.forEach(function (item) {
          delete item.dataset.open;
          let btn = item.querySelector('[aria-haspopup]');
          btn && btn.setAttribute('aria-expanded', 'false');
          let panel = item.querySelector('.mega-panel');
          panel && panel.classList.remove('is-open');
          panel && panel.setAttribute('aria-hidden', 'true');
        });
      }

      megaItems.forEach(function (item) {
        let btn = item.querySelector('[aria-haspopup]');
        let panel = item.querySelector('.mega-panel');
        if (!btn || !panel) return;

        let closeTimer;

        function open() {
          clearTimeout(closeTimer);
          closeAllMega();
          item.dataset.open = 'true';
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        }

        function scheduleClose() {
          closeTimer = setTimeout(function () {
            delete item.dataset.open;
            btn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
          }, 120);
        }

        if (!clickOnly) {
          btn.addEventListener('mouseenter', open);
          item.addEventListener('mouseleave', scheduleClose);
          panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
          panel.addEventListener('mouseleave', scheduleClose);
        }

        btn.addEventListener('click', function () {
          if (item.dataset.open) { closeAllMega(); } else { open(); }
        });

        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { closeAllMega(); btn.focus(); }
          if (e.key === 'ArrowDown' && panel.classList.contains('is-open')) {
            e.preventDefault();
            let firstLink = panel.querySelector('a');
            firstLink && firstLink.focus();
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!header.contains(e.target)) closeAllMega();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAllMega();
      });
    }

    /* ── Cart count sync ── */
    let cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) {
      cartToggle.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    }

    document.addEventListener('cart:updated', function () {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiteHeader);
  } else {
    initSiteHeader();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId && document.getElementById('site-header')) {
      initSiteHeader();
    }
  });

  document.addEventListener('change', function (e) {
    let select = e.target.closest('select[data-auto-submit]');
    if (select) select.closest('form').submit();
  });
